import React from 'react';
import {styled} from "@mui/material/styles";
import {Typography} from "@mui/material";
import ColorSliders from "../ColorSliders";
import InputSection from "../InputSection";
import StatsSection from "../StatsSection";
import grey from "@mui/material/colors/grey";
import HelpMenu from "../HelpMenu";
import ImagePreviewSection from "../ImagePreviewSection";
import Box from "@mui/material/Box";
import ButtonSection from "../sidebar/ButtonSection";


const StyledBox = styled(Box)(({theme}) => ({
    minHeight: '100vh',
    minWidth: `100vw`,
    width: '100vw',
    overflowX: 'hidden',
    backgroundColor: '#151515',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
}));

const StyledTitle = styled(Typography)(({theme}) => ({
    margin: theme.spacing(0, 0, 1, 0),
    backgroundColor: grey[900],
    textAlign: 'center',
    width: '100vw',
    padding: theme.spacing(1),
    borderBottom: '1px solid black',
    boxShadow: '0 5px 5px rgba(0,0,0,.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
}));

const StyledContent = styled(Box)(({theme}) => ({
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(5),
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'column',
    minHeight: '100vh',
    width: `100vw`,
    backgroundColor: '#151515',
}));


export default function MobileLayout() {

    return (
        <StyledBox>
            <StyledTitle>
                <Typography variant={'h3'}>AMOLED-ify</Typography>
                <HelpMenu/>
            </StyledTitle>
            <InputSection/>
            <StyledContent>
                <ImagePreviewSection/>
                <ColorSliders/>
                <ButtonSection/>
                <StatsSection/>
            </StyledContent>
        </StyledBox>
    );
}

